// =====================================
//
//   確認退款 Modal
//   Author: Wayne
//   createtime: 2016 / 03 / 29
//   updatetime: 2016 / 03 / 29
//
// =====================================
// confirm_payment
window.InifECMobileApp.directive('confirmPayment', ['$rootScope', '$stateParams', '$timeout', '$ngModal', '$state', 'UserService', 'OrderService', 'PointService', 'ShoppingCartService', 'BonusPointsService', 'ProductUtil',
    function($rootScope, $stateParams, $timeout, $ngModal, $state, UserService, OrderService, PointService, ShoppingCartService, BonusPointsService, ProductUtil) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('confirm-payment-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('confirm-payment-modal');
            }

            // --------------------------------
            // 取消
            // --------------------------------
            var cancel = function() {
                
                if($scope.isUpdate || $scope.isSetPaying) {
                    return;
                }

                closeModal();
            }

            // --------------------------------
            // [private] 取得訂單資訊
            // --------------------------------
            var getOrderInfo = function() {

                OrderService.getOrderInfo($scope.orderid).then(function(result) {
                    if(result) {
                        $scope.order = result;

                        // 舊流程防呆，如果已經使用紅利就跳過確認流程
                        if($scope.order.bonusPointsDiscount > 0) {
                            $scope.order.isConfirmPayment = true;
                        }

                        if($scope.order.ispaid || ($scope.order.orderstatus != 250 && $scope.order.orderstatus != 300)) {
                            $scope.isStatusError = true;
                        } else {
                            initOrder();
                        }
                    }

                    $scope.isLoading = false;

                }, function(error) {
                    
                    $scope.isError = true;
                    $scope.isLoading = false;
                });
            }

            // --------------------------------
            // [private] 初始化訂單資訊
            // --------------------------------
            var initOrder = function() {

                if($scope.order.isConfirmPayment) {
                    $scope.paymentmethod = Paytype_SinopacATM;
                    // $scope.paymentmethod = Paytype_OutwardRemittance;

                    if($scope.order.paymentmethod > 0) {
                        $scope.paymentmethod = $scope.order.paymentmethod;
                    }

                    if($scope.paymentmethod == Paytype_SinopacATM) {
                        getAtmInfo();
                    }
                } else {
                    $scope.form.invoiceType = $scope.order.invoiceType || 'dualCopy';
                    $scope.form.invoiceTitle = $scope.order.invoiceTitle;
                    $scope.form.VATNumber = $scope.order.VATNumber;
                    $scope.form.isDonate = $scope.order.isDonate;
                    $scope.form.loveCode = $scope.order.loveCode;
                    $scope.form.carrierType = $scope.order.carrierType || 'memberCarrier';
                    $scope.form.digitalCitizenCarrierID = $scope.order.digitalCitizenCarrierID;
                    $scope.form.mobilePhoneCarrierID = $scope.order.mobilePhoneCarrierID;

                    if($scope.form.loveCode) {
                        for(var i = 0; i < $scope.loveCodeList.length; i++) {
                            if($scope.form.loveCode == $scope.loveCodeList[i].code) {
                                $scope.form.selectLoveCode = $scope.loveCodeList[i];
                                break;
                            }
                        }   
                    }

                    initDelivery();
                    refreshPrice();
                }
            }

            // --------------------------------
            // [private] 取得atm資訊
            // --------------------------------
            var getAtmInfo = function() {

                if($scope.order.paymentlogs && $scope.order.paymentlogs.logs && $scope.order.paymentlogs.logs.length > 0) {

                    try {

                        var alllogs = $scope.order.paymentlogs.logs;

                        for(var i = 0; i < alllogs.length; i++){
                            var logid = alllogs[i][0];
                            if(logid.paytype == Paytype_SinopacATM) {
                                var log = alllogs[i][1]

                                $scope.atminfo = angular.fromJson(log.gatewayRstJSON);
                                break;
                            }
                        }

                    } catch (e) {
                        console.log(e);
                    }
                }
            }

            // --------------------------------
            // [private] 取得總價
            // --------------------------------
            var refreshPrice = function() {

                $scope.form.productTotal = getTotalPrice();

                checkShippingFee();
                checkbonusPointsDiscount($scope.form.productTotal);
            }

            // --------------------------------
            // [private] 取得商品總價
            // --------------------------------
            var getTotalPrice = function() {

                var productTotal = 0;
                var order = $scope.order;

                if(order.orderitems && order.orderitems.length > 0) {
                    for(var i = 0; i < order.orderitems.length; i++) {
                        var orderitem = order.orderitems[i];

                        productTotal += _getProductTotalPrice(orderitem);
                    }
                }

                return productTotal;
            }

            // --------------------------------
            // [private] 取得商品總價
            // --------------------------------
            var _getProductTotalPrice = function(orderitem) {

                return ShoppingCartService.getProductTotalPrice(orderitem);
            }

            // --------------------------------
            // [private] 取得會員點數餘額
            // --------------------------------
            var getMemberPointsBalance = function(isFirstLoad) {

                PointService.getMemberPointsBalance().then(function(result){
                    if(result){
                        $scope.pointsBalanceRec = result;
                        $scope.points = $scope.pointsBalanceRec.pointsbalance;
                        $scope.pointsEnableFlag = $scope.pointsBalanceRec.enableflag;
                        $scope.userpointtype = $scope.pointsBalanceRec.userpointtype;
                    }

                    if(isFirstLoad) {
                        getUserBonusPoints();
                    }
                }, function(error) {
                    if(isFirstLoad) {
                        getUserBonusPoints();
                    }
                });
            }

            // --------------------------------
            // 選擇付款方式
            // --------------------------------
            var changePaymentMethod = function(paymentmethod) {

                $scope.paymentmethod = paymentmethod;

                // if(paymentmethod == Paytype_Point || paymentmethod == Paytype_Monthly){
                //     getMemberPointsBalance();
                // }
            }

            // --------------------------------
            // 決定付款方式
            // --------------------------------
            var setPayType = function(){

                if($scope.isSetPaying) {
                    return;
                }

                if($scope.paymentmethod == Paytype_Point 
                    && ($scope.points <= 0 || !$scope.pointsEnableFlag || $scope.order.totalamount > $scope.points) 
                ){
                    return;
                }

                if($scope.paymentmethod == Paytype_Monthly 
                    && ($scope.points <= 0 || !$scope.pointsEnableFlag || $scope.order.totalamount > $scope.points) 
                ){
                    return;
                }

                var title = '確定付款嗎？';
                var description;

                if($scope.paymentmethod == Paytype_SinopacATM) {
                    description = '將使用Atm付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_SinopacCreditCard){
                    description = '將使用信用卡付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_Point){
                    description = '將使用預儲點數付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_OutwardRemittance) {
                    description = '將使用臨櫃付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_Spgateway_Cvs) {
                    description = '將使用超商付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_Monthly) {
                    description = '將使用月結點數付款，確定嗎？';
                }

                $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                    title: title,
                    description: description,
                    callback: function(result) {
                        if(result) {
                            $scope.isSetPaying = true;

                            OrderService.setPayType($scope.orderid, $scope.paymentmethod).then(function(result) {
                                if(result) {
                                    if($scope.paymentmethod == Paytype_SinopacATM) {
                                        $state.go(window.STATES.PAYMENT_SINOPACATM, {orderid: $scope.orderid});
                                    } else if($scope.paymentmethod == Paytype_SinopacCreditCard){
                                        $state.go(window.STATES.PAYMENT_SINOPACCREDITCARD, {orderid: $scope.orderid});
                                    } else if($scope.paymentmethod == Paytype_Point){
                                        $state.go(window.STATES.PAYMENT_POINT, {orderid: $scope.orderid});
                                    } else if($scope.paymentmethod == Paytype_OutwardRemittance) {
                                        $state.go(window.STATES.PAYMENT_OUTWARDREMITTANCE, {orderid: $scope.orderid});
                                    } else if($scope.paymentmethod == Paytype_Spgateway_Cvs) {
                                        $state.go(window.STATES.PAYMENT_SPGATEWAYCVS, {orderid: $scope.orderid});
                                    } else if($scope.paymentmethod == Paytype_Monthly) {
                                        $state.go(window.STATES.PAYMENT_MONTHLY, {orderid: $scope.orderid});
                                    }
                                }

                                $scope.isSetPaying = false;
                                closeModal();
                            }, function(error) {
                                $scope.isError = true;
                                $scope.isSetPaying = false;
                            });
                        }
                    }
                });
            }

            // -------------------------------
            // [private] 初始化訂單配送資訊
            // -------------------------------
            var initDelivery = function() {

                // 檢查是否有限自取的商品
                $scope.hasOnlySelfTotal = false;

                for(var i = 0 ; i < $scope.order.orderitems.length ; i++){
                    var item = $scope.order.orderitems[i];

                    if(item.spec && item.spec.productDelivery == ProductUtil.ProductDeliveryType.ONLY_SELF) {
                        $scope.hasOnlySelfTotal = true;
                        break;
                    }
                }

                if($scope.hasOnlySelfTotal) {
                    $scope.form.delivery = OrderDeliveryType.SELF;
                } else {
                    $scope.form.delivery = $scope.order.delivery;
                }

                if($scope.form.delivery == OrderDeliveryType.HOME || $scope.form.delivery == OrderDeliveryType.TEXI) {
                    $scope.form.postal = $scope.order.addressInfo.postal;
                    $scope.form.address = $scope.order.addressInfo.address;
                    $scope.form.city = '';
                    $scope.form.dist = '';
                    $scope.form.newAddress = '';
                    $scope.form.name = $scope.order.addressInfo.name;
                    $scope.form.mobilephone = $scope.order.addressInfo.mobilephone;
                    $scope.form.phone = $scope.order.addressInfo.phone;
                    $scope.form.phoneExtension = $scope.order.addressInfo.phoneExtension;
                    $scope.form.shippingFee = $scope.order.shippingFee;
                    $scope.form.defaultShippingFee = $scope.order.defaultShippingFee;
                    $scope.form.largeShippingFee = $scope.order.largeShippingFee;

                    $scope.form.isConfidentialDelivery = $scope.order.isConfidentialDelivery;
                    $scope.form.confidentialFee = $scope.order.confidentialFee;

                    if($scope.form.isConfidentialDelivery) {
                        $scope.form.senderpostal = $scope.order.senderInfo.postal;
                        $scope.form.senderaddress = $scope.order.senderInfo.address;
                        $scope.form.sendername = $scope.order.senderInfo.name;
                        $scope.form.sendermobilephone = $scope.order.senderInfo.mobilephone;
                        $scope.form.senderphone = $scope.order.senderInfo.phone;
                        $scope.form.senderphoneExtension = $scope.order.senderInfo.phoneExtension;
                    }

                    checkShippingFee();
                } else {
                    $scope.form.postal = undefined;
                    $scope.form.address = undefined;
                    $scope.form.city = '';
                    $scope.form.dist = '';
                    $scope.form.newAddress = '';
                    $scope.form.name = undefined;
                    $scope.form.mobilephone = undefined;
                    $scope.form.phone = undefined;
                    $scope.form.phoneExtension = undefined;
                    $scope.form.shippingFee = 0;
                    $scope.form.defaultShippingFee = 0;
                    $scope.form.largeShippingFee = 0;
                    $scope.form.isConfidentialDelivery = false;
                    $scope.form.confidentialFee = 0;
                    $scope.form.senderpostal = undefined;
                    $scope.form.senderaddress = undefined;
                    $scope.form.sendername = undefined;
                    $scope.form.sendermobilephone = undefined;
                    $scope.form.senderphone = undefined;
                    $scope.form.senderphoneExtension = undefined;
                }
            }

            // -------------------------------
            // [private] 檢查運費
            // -------------------------------
            var checkShippingFee = function() {

                if($scope.form.delivery == OrderDeliveryType.SELF || $scope.form.delivery == OrderDeliveryType.TEXI) {
                    $scope.form.shippingFee = 0;
                    $scope.form.defaultShippingFee = 0;
                    $scope.form.largeShippingFee = 0;
                    return;
                }

                // 巧昱運費為報價，就不用依照地址而變動
                $scope.form.shippingFee = $scope.order.shippingFee;
                $scope.form.defaultShippingFee = $scope.order.defaultShippingFee;
                $scope.form.largeShippingFee = $scope.order.largeShippingFee;

                // var isFreeShipping = true;
                // var defaultTotal = 0;
                // var largeTotal = 0;
                // $scope.form.defaultShippingFee = 0;
                // $scope.form.largeShippingFee = 0;

                // for(var i = 0 ; i < $scope.order.orderitems.length ; i++){
                //     var item = $scope.order.orderitems[i];

                //     isFreeShipping = isFreeShipping && item.label == ProductUtil.ProductLabel.LABEL_FREE_SHIPPING;

                //     if(item.spec && item.spec.productDelivery == ProductUtil.ProductDeliveryType.DEFAULT) {
                //         defaultTotal += _getProductTotalPrice(item);
                //     } else if(item.spec && item.spec.productDelivery == ProductUtil.ProductDeliveryType.LARGE) {
                //         largeTotal += _getProductTotalPrice(item);

                //     }
                // }

                // $scope.isFreeShipping = isFreeShipping;

                // var _otherShippingFee = 0;
                // var _largeShippingFee = 0;

                // if($scope.form.shippingFeeInfo) {
                //     _otherShippingFee = $scope.form.shippingFeeInfo.otherShippingFee || 0;
                //     _largeShippingFee = $scope.form.shippingFeeInfo.largeShippingFee || 0;
                // }

                // // [一般商品] 非偏遠地方時 全免運商品 或 總價大於一千，則免運
                // if(defaultTotal > 0) {
                //     if(_otherShippingFee == 0 && (isFreeShipping || defaultTotal >= 1000)) {
                //         $scope.form.defaultShippingFee = 0;
                //     } else {
                //         $scope.form.defaultShippingFee = 88 + _otherShippingFee;
                //     }
                // }

                // // [大商品] 專車運費
                // if (largeTotal > 0) {
                //     $scope.form.largeShippingFee = _largeShippingFee;
                // }

                // $scope.form.shippingFee = $scope.form.defaultShippingFee + $scope.form.largeShippingFee;
            }

            // -------------------------------
            // 更改運送方式
            // -------------------------------
            var changeDelivery = function(delivery) {

                $scope.form.delivery = delivery;
                if($scope.form.delivery == OrderDeliveryType.SELF) {
                    $scope.form.shippingFee = 0;
                }

                checkShippingFee();
                checkConfidentialFee();
            }

            // -------------------------------
            // 編輯收件資訊
            // -------------------------------
            var editDelivery = function() {

                $rootScope.$broadcast('OPEN_EDIT_DELIVERY_MODAL', {
                    // 收件人
                    delivery: $scope.form.delivery,
                    postal: $scope.form.postal,
                    address: $scope.form.address,
                    name: $scope.form.name,
                    mobilephone: $scope.form.mobilephone,
                    phone: $scope.form.phone,
                    phoneExtension: $scope.form.phoneExtension,
                    isSaveAddress: $scope.form.isSaveAddress,
                    // 收件人錯誤狀態
                    isAddressEmpty: $scope.isAddressEmpty,
                    isNameEmpty: $scope.isNameEmpty,
                    isMobilePhoneEmpty: $scope.isMobilePhoneEmpty,
                    isMobilePhoneError: $scope.isMobilePhoneError,
                    isPostalEmpty: $scope.isPostalEmpty,
                    isPostalError: $scope.isPostalError,
                    // 寄件人
                    isConfidentialDelivery: $scope.form.isConfidentialDelivery,
                    sendername: $scope.form.sendername,
                    senderaddress: $scope.form.senderaddress,
                    senderpostal: $scope.form.senderpostal,
                    senderphone: $scope.form.senderphone,
                    sendermobilephone: $scope.form.sendermobilephone,
                    senderphoneExtension: $scope.form.senderphoneExtension,
                    isSaveSenderAddress: $scope.form.isSaveSenderAddress,
                    // 寄件人錯誤狀態
                    isSenderNameEmpty: $scope.isSenderNameEmpty,
                    isSenderMobilePhoneEmpty: $scope.isSenderMobilePhoneEmpty,
                    isSenderMobilePhoneError: $scope.isSenderMobilePhoneError,
                    isSenderPostalEmpty: $scope.isSenderPostalEmpty,
                    isSenderPostalError: $scope.isSenderPostalError,
                    isSenderAddressEmpty: $scope.isSenderAddressEmpty,

                    isShowSaveButton: false,
                    callback: function(delivery, addressInfo, isConfidentialDelivery, senderInfo, statusResult, shippingFeeInfo) {

                        if(delivery === undefined || addressInfo === undefined || statusResult === undefined) {
                            return;
                        }

                        if(isConfidentialDelivery && senderInfo === undefined) {
                            return;
                        }

                        $scope.form.delivery = delivery;
                        $scope.form.shippingFeeInfo = shippingFeeInfo;
                        $scope.form.isConfidentialDelivery = isConfidentialDelivery;

                        // 選擇宅配才更新目前資訊
                        if(delivery == 1) {
                            $scope.form.postal = addressInfo.postal;
                            $scope.form.address = addressInfo.address;
                            $scope.form.name = addressInfo.name;
                            $scope.form.mobilephone = addressInfo.mobilephone;
                            $scope.form.phone = addressInfo.phone;
                            $scope.form.phoneExtension = addressInfo.phoneExtension;
                            $scope.form.isSaveAddress = addressInfo.isSaveAddress;
                            // 錯誤狀態
                            $scope.isAddressEmpty = statusResult.isAddressEmpty;
                            $scope.isNameEmpty = statusResult.isNameEmpty;
                            $scope.isMobilePhoneEmpty = statusResult.isMobilePhoneEmpty;
                            $scope.isMobilePhoneError = statusResult.isMobilePhoneError;
                            $scope.isPostalEmpty = statusResult.isPostalEmpty;
                            $scope.isPostalError = statusResult.isPostalError;

                            // 選擇保密待寄才更新資料
                            if(isConfidentialDelivery) {
                                $scope.form.sendername = senderInfo.sendername;
                                $scope.form.senderaddress = senderInfo.senderaddress;
                                $scope.form.senderpostal = senderInfo.senderpostal;
                                $scope.form.senderphone = senderInfo.senderphone;
                                $scope.form.sendermobilephone = senderInfo.sendermobilephone;
                                $scope.form.senderphoneExtension = senderInfo.senderphoneExtension;
                                $scope.form.isSaveSenderAddress = senderInfo.isSaveSenderAddress;
                                // 錯誤狀態
                                $scope.isSenderNameEmpty = statusResult.isSenderNameEmpty;
                                $scope.isSenderMobilePhoneEmpty = statusResult.isSenderMobilePhoneEmpty;
                                $scope.isSenderMobilePhoneError = statusResult.isSenderMobilePhoneError;
                                $scope.isSenderPostalEmpty = statusResult.isSenderPostalEmpty;
                                $scope.isSenderPostalError = statusResult.isSenderPostalError;
                                $scope.isSenderAddressEmpty = statusResult.isSenderAddressEmpty;
                            }
                        }

                        changeDelivery($scope.form.delivery);
                    }
                });
            }

            // -------------------------------
            // 收件人資訊是否有誤
            // -------------------------------
            var isAddressInfoError = function() {

                return $scope.isAddressEmpty || $scope.isNameEmpty || $scope.isMobilePhoneEmpty || $scope.isMobilePhoneError 
                        || $scope.isPostalEmpty || $scope.isPostalError;
            }

            // --------------------------------
            // [private] 檢查會員是否為企業用戶
            // --------------------------------
            var checkIsBusinessMember = function() {

                if($scope.user.membertype == 1 && $scope.user.businessmrscid) {
                    $scope.isBusinessMember = true;

                    changeInvoiceTypeAndDonate('triCopy', false);
                }
            }

            // -------------------------------
            // [private] 取得紅利餘額
            // -------------------------------
            var getUserBonusPoints = function() {

                BonusPointsService.getUserBonusPoints().then(function(result) {
                    if($scope.userBonusPoints.bonusRemainder == 0) {
                        $scope.form.isUseBonusPointsDiscount = false;
                    }
                    getOrderInfo();
                }, function(error) {
                    $scope.form.isUseBonusPointsDiscount = false;
                    getOrderInfo();
                });
            }

            // -------------------------------
            // 是否使用紅利折抵
            // -------------------------------
            var toggleIsUseBonusPointsDiscount = function() {
                
                $scope.form.isUseBonusPointsDiscount = !$scope.form.isUseBonusPointsDiscount;
            }

            // -------------------------------
            // [private] 檢查該次可使用的紅利
            // -------------------------------
            var checkbonusPointsDiscount = function(total) {

                if($scope.userBonusPoints.bonusRemainder == 0) {
                    return;
                }

                var bonusPointsDiscount = Math.floor(total * 0.1);

                bonusPointsDiscount = Math.min(bonusPointsDiscount, $scope.userBonusPoints.bonusRemainder);

                $scope.form.bonusPointsDiscount = bonusPointsDiscount;
            }

            // -------------------------------
            // 付款前的最後確認（可更改運送方式、發票以及紅利折抵）
            // -------------------------------
            var confirmOrderBeforePayment = function() {

                if($scope.isUpdate) {
                    return;
                }

                var isParamsError = false;

                $scope.isAddressEmpty = false;
                $scope.isNameEmpty = false;
                $scope.isMobilePhoneEmpty = false;
                $scope.isMobilePhoneError = false;
                $scope.isPostalEmpty = false;
                $scope.isPostalError = false;
                $scope.invoiceTitleEmpty = false;
                $scope.VATNumberEmpty = false;
                $scope.VATNumberError = false;
                $scope.isSenderAddressEmpty = false;
                $scope.isSenderNameEmpty = false;
                $scope.isSenderMobilePhoneEmpty = false;
                $scope.isSenderMobilePhoneError = false;
                $scope.isSenderPostalEmpty = false;
                $scope.isSenderPostalError = false;
                $scope.isDigitalCitizenCarrierIDEmpty = false;
                $scope.isDigitalCitizenCarrierIDError = false;
                $scope.isMobilePhoneCarrierIDEmpty = false;
                $scope.isMobilePhoneCarrierIDError = false;
                $scope.isLoveCodeEmpty = false;
                $scope.isInvoiceEmpty = false;
                $scope.isCompanyEmpty = false;
                $scope.isParamsError = false;

                // 檢查收件者地址是否有正確填入
                var _addressInfo = undefined;
                if($scope.form.delivery == OrderDeliveryType.HOME) {
                    if(!$scope.form.address || !$scope.form.newAddress) {
                        $scope.isAddressEmpty = true;
                        isParamsError = true;
                    }

                    if(!$scope.form.name) {
                        $scope.isNameEmpty = true;
                        isParamsError = true;
                    }

                    if(!$scope.form.mobilephone) {
                        $scope.isMobilePhoneEmpty = true;
                        isParamsError = true;
                    }

                    if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                        $scope.isMobilePhoneError = true;
                        isParamsError = true;
                    }

                    if(!$scope.form.postal) {
                        $scope.isPostalEmpty = true;
                        isParamsError = true;
                    }

                    if($scope.form.postal && isNaN($scope.form.postal)) {
                        $scope.isPostalError = true;
                        isParamsError = true;
                    }

                    _addressInfo = {
                        name: $scope.form.name,
                        address: $scope.form.address,
                        postal: $scope.form.postal,
                        phone: $scope.form.phone,
                        mobilephone: $scope.form.mobilephone,
                        phoneExtension: $scope.form.phoneExtension,
                    }
                }

                var _senderInfo = undefined;
                if($scope.form.isConfidentialDelivery) {
                    if(!$scope.form.senderaddress) {
                        $scope.isSenderAddressEmpty = true;
                        isParamsError = true;
                    }

                    if(!$scope.form.sendername) {
                        $scope.isSenderNameEmpty = true;
                        isParamsError = true;
                    }

                    if(!$scope.form.sendermobilephone) {
                        $scope.isSenderMobilePhoneEmpty = true;
                        isParamsError = true;
                    }

                    if($scope.form.sendermobilephone && !isPhone($scope.form.sendermobilephone)) {
                        $scope.isSenderMobilePhoneError = true;
                        isParamsError = true;
                    }

                    if(!$scope.form.senderpostal) {
                        $scope.isSenderPostalEmpty = true;
                        isParamsError = true;
                    }

                    if($scope.form.senderpostal && isNaN($scope.form.senderpostal)) {
                        $scope.isSenderPostalError = true;
                        isParamsError = true;
                    }

                    _senderInfo = {
                        name: $scope.form.sendername,
                        address: $scope.form.senderaddress,
                        postal: $scope.form.senderpostal,
                        phone: $scope.form.senderphone,
                        mobilephone: $scope.form.sendermobilephone,
                        phoneExtension: $scope.form.senderphoneExtension,
                    }
                }

                // 檢查發票資訊是否填寫正確
                if(!$scope.isBusinessMember) {

                    if($scope.form.invoiceType === 'dualCopy' && !$scope.form.isDonate) {

                        if($scope.form.carrierType === 'digitalCitizenCarrier') {

                            if(!$scope.form.digitalCitizenCarrierID) {
                                $scope.isDigitalCitizenCarrierIDEmpty = true;
                                isParamsError = true;
                            } else if(!isDigitalCitizenCarrierID($scope.form.digitalCitizenCarrierID)) {
                                $scope.isDigitalCitizenCarrierIDError = true;
                                isParamsError = true;
                            }
                        }

                        if($scope.form.carrierType === 'mobilePhoneCarrier') {
                            if(!$scope.form.mobilePhoneCarrierID) {
                                $scope.isMobilePhoneCarrierIDEmpty = true;
                                isParamsError = true;
                            } else if(!isMobilePhoneCarrierID($scope.form.mobilePhoneCarrierID)) {
                                $scope.isMobilePhoneCarrierIDError = true;
                                isParamsError = true;
                            }
                        }
                    } else if($scope.form.invoiceType === 'dualCopy' && $scope.form.isDonate) {
                        if($scope.form.selectLoveCode.code == '-1' && !$scope.form.loveCode) {
                            $scope.isLoveCodeEmpty = true;
                            isParamsError = true;
                        }
                    } else if($scope.form.invoiceType === 'triCopy') {
                        if(!$scope.form.VATNumber) {
                            $scope.VATNumberEmpty = true;
                            isParamsError = true;
                        } else if(!isTaxIDNumber($scope.form.VATNumber)) {
                            $scope.VATNumberError = true;
                            isParamsError = true;
                        }

                        if(!$scope.form.invoiceTitle) {
                            $scope.invoiceTitleEmpty = true;
                            isParamsError = true;
                        }
                    }
                } else {
                    if(!isTaxIDNumber($scope.form.VATNumber)) {
                        $scope.VATNumberError = true;
                        isParamsError = true;
                    }
                }

                if(isParamsError) {
                    $scope.isParamsError = true;
                    return;
                }

                $scope.isUpdate = true;
                $scope.isUpdateError = false;

                var orderid = $scope.orderid,
                    delivery = $scope.form.delivery,                
                    addressInfo = $scope.form.delivery == OrderDeliveryType.HOME ? JSON.stringify(_addressInfo):undefined,
                    senderInfo = $scope.form.isConfidentialDelivery ? JSON.stringify(_senderInfo):undefined,
                    isConfidentialDelivery = $scope.form.isConfidentialDelivery,
                    invoiceTitle = $scope.form.invoiceType === 'triCopy' ? $scope.form.invoiceTitle : undefined,
                    VATNumber = $scope.form.invoiceType === 'triCopy' ? $scope.form.VATNumber : undefined,
                    bonusPointsDiscount = $scope.form.isUseBonusPointsDiscount ? $scope.form.bonusPointsDiscount : 0,
                    isUseBonusPointsDiscount = $scope.form.isUseBonusPointsDiscount,
                    invoiceType = $scope.form.invoiceType, 
                    carrierType = $scope.form.carrierType, 
                    loveCode = '',
                    digitalCitizenCarrierID = $scope.form.digitalCitizenCarrierID, 
                    mobilePhoneCarrierID = $scope.form.mobilePhoneCarrierID, 
                    isDonate = $scope.form.isDonate;

                if($scope.form.isDonate) {
                    loveCode = $scope.form.selectLoveCode.code == '-1' ? $scope.form.loveCode : $scope.form.selectLoveCode.code;
                }

                OrderService.confirmOrderBeforePayment(orderid, delivery, addressInfo, senderInfo, isConfidentialDelivery, 
                    invoiceTitle, VATNumber, bonusPointsDiscount, isUseBonusPointsDiscount, invoiceType, carrierType, loveCode, digitalCitizenCarrierID, 
                    mobilePhoneCarrierID, isDonate)
                .then(function(result) {

                    if(result) {
                        $scope.order = result;
                        
                        initOrder();
                        ($scope.confirmOrderCallback) && $scope.confirmOrderCallback();
                    } else {
                        $scope.isUpdateError = true;
                    }

                    $scope.isUpdate = false;

                }, function(error) {

                    $scope.isUpdate = false;
                    $scope.isUpdateError = true;
                });
            }

            // -------------------------------
            // [private] 檢查保密代寄費用
            // -------------------------------
            var checkConfidentialFee = function() {

                if($scope.form.delivery == OrderDeliveryType.HOME && $scope.form.isConfidentialDelivery) {
                    $scope.form.confidentialFee = 0;
                } else {
                    $scope.form.confidentialFee = 0;
                }
            }

            // -------------------------------
            // 取得總價（呈現在畫面上的）
            // -------------------------------
            var getViewResultPrice = function() {

                var total = $scope.form.productTotal;

                total += $scope.form.shippingFee;
                total += $scope.form.confidentialFee;

                if($scope.form.isUseBonusPointsDiscount && !$scope.hasOfferProcess) {
                    total -= $scope.form.bonusPointsDiscount;
                }

                return window.Math.round(total * 1.05);
            }

            // ------------------------------
            // 更新發票選項
            // ------------------------------
            var changeInvoiceTypeAndDonate = function(invoiceType, isDonate) {

                $scope.form.invoiceType = invoiceType;
                $scope.form.isDonate = isDonate;

                if(isDonate) {
                    changeCarrierType('memberCarrier');
                }
            }

            // ------------------------------
            // 更新發票種類
            // ------------------------------
            var changeCarrierType = function(carrierType) {

                $scope.form.carrierType = carrierType;
            }

            // --------------------------------
            // [private] 初始化
            // --------------------------------
            var init = function() {

                $scope.isLoading = true;
                UserService.getUserInfo().then(function(result){
                    $scope.user = result;

                    checkIsBusinessMember();
                    // getMemberPointsBalance(true);
                    getOrderInfo();

                }, function(error){
                    $scope.isLoading = false;
                    $scope.isError = true;
                });
            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_CONFIRM_PAYMENT_MODAL", function(event, data) {

                if(data) {
                    $scope.orderid = data.orderid;
                    $scope.confirmOrderCallback = data.confirmOrderCallback;

                    $scope.isLoading = false;
                    $scope.isError = false;
                    $scope.isAddressEmpty = false;
                    $scope.isNameEmpty = false;
                    $scope.isMobilePhoneEmpty = false;
                    $scope.isMobilePhoneError = false;
                    $scope.isPostalEmpty = false;
                    $scope.isPostalError = false;
                    $scope.isSenderAddressEmpty = false;
                    $scope.isSenderNameEmpty = false;
                    $scope.isSenderMobilePhoneEmpty = false;
                    $scope.isSenderMobilePhoneError = false;
                    $scope.isSenderPostalEmpty = false;
                    $scope.isSenderPostalError = false;
                    $scope.invoiceTitleEmpty = false;
                    $scope.VATNumberEmpty = false;
                    $scope.VATNumberError = false;
                    $scope.isParamsError = false;
                    $scope.isPostAddressHint = false;
                    $scope.isStatusError = false;

                    init();
                    openModal();
                }
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.order;
            $scope.orderid;
            $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;
            
            $scope.isLoading = false;
            $scope.isError = false;
            $scope.isAddressEmpty = false;
            $scope.isNameEmpty = false;
            $scope.isMobilePhoneEmpty = false;
            $scope.isMobilePhoneError = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isSenderAddressEmpty = false;
            $scope.isSenderNameEmpty = false;
            $scope.isSenderMobilePhoneEmpty = false;
            $scope.isSenderMobilePhoneError = false;
            $scope.isSenderPostalEmpty = false;
            $scope.isSenderPostalError = false;
            $scope.invoiceTitleEmpty = false;
            $scope.VATNumberEmpty = false;
            $scope.VATNumberError = false;
            $scope.isParamsError = false;
            $scope.isPostAddressHint = false;
            $scope.isStatusError = false;
            $scope.paymentmethod = Paytype_SinopacCreditCard;
            // $scope.paymentmethod = Paytype_OutwardRemittance;
            $scope.pointsBalanceRec;
            $scope.points = 0;
            $scope.pointsEnableFlag = true;
            $scope.Math = window.Math;
            
            $scope.form = {
                delivery: OrderDeliveryType.SELF,
                postal: undefined, // 收件者郵遞區號
                address: undefined, // 收件者地址
                city: '',
                dist: '',
                newAddress: '',
                name: undefined, // 收件者名稱
                mobilephone: undefined, // 收件者手機
                phone: undefined, // 收件者市話
                phoneExtension: undefined, // 收件者分機
                senderpostal: undefined, // 保密代寄寄件人郵遞區號
                senderaddress: undefined, // 保密代寄寄件人地址
                sendername: undefined, // 保密代寄寄件人名稱
                sendermobilephone: undefined, // 保密代寄寄件人手機
                senderphone: undefined, // 保密代寄寄件人市話
                senderphoneExtension: undefined, // 保密代寄寄件人分機
                isConfidentialDelivery: false, // 是否為保密待機
                shippingFee: 0, // 運費
                shippingFeeInfo: undefined,
                defaultShippingFee: 0, // 一般商品的運費（含偏遠費）
                largeShippingFee: 0, // 大商品專車運費
                isUseBonusPointsDiscount: true, // 是否要用紅利折抵
                bonusPointsDiscount: 0, // 本次消費可用紅利
                productTotal: 0, // 商品總額
                confidentialFee: 0, // 保密代寄費用

                // 發票相關
                invoiceTitle: undefined, // 發票標題
                VATNumber: undefined, // 發票號碼
                invoiceType: 'dualCopy',
                isDonate: false,
                carrierType: 'memberCarrier',
                loveCode: undefined,
                digitalCitizenCarrierID: undefined,
                mobilePhoneCarrierID: undefined,
                selectLoveCode: default_loveCodeList[0],
            };

            $scope.userBonusPoints = BonusPointsService.lastBonusPoints;
            $scope.userpointtype = -1;
            $scope.isDigitalCitizenCarrierIDEmpty = false;
            $scope.isDigitalCitizenCarrierIDError = false;
            $scope.isMobilePhoneCarrierIDEmpty = false;
            $scope.isMobilePhoneCarrierIDError = false;
            $scope.isLoveCodeEmpty = false;
            $scope.isInvoiceEmpty = false;
            $scope.isCompanyEmpty = false;
            $scope.loveCodeList = default_loveCodeList;
            $scope.hasOnlySelfTotal = false;

            /*==========================
                Methods
            ==========================*/
            $scope.confirmOrderCallback = undefined;
            $scope.cancel = cancel; // 取消
            $scope.changePaymentMethod = changePaymentMethod; // 選擇付款方式
            $scope.setPayType = setPayType; // 決定付款方式
            $scope.changeDelivery = changeDelivery; // 更改運送方式
            $scope.editDelivery = editDelivery; // 編輯收件資訊
            $scope.isAddressInfoError = isAddressInfoError; // 收件人資訊是否有誤
            $scope.toggleIsUseBonusPointsDiscount = toggleIsUseBonusPointsDiscount; // 是否使用紅利折抵
            $scope.confirmOrderBeforePayment = confirmOrderBeforePayment; // 付款前的最後確認（可更改運送方式、發票以及紅利折抵）        
            $scope.getViewResultPrice = getViewResultPrice; // 取得總價（呈現在畫面上的）
            $scope.changeInvoiceTypeAndDonate = changeInvoiceTypeAndDonate; // 更新發票選項
            $scope.changeCarrierType = changeCarrierType; // 更新發票種類

            /*==========================
                init
            ==========================*/
        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/confirm_payment.html';
        _dir.controller = controller;

        return _dir;
}]);